var _line, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.99995,
    y1: 2.07963,
    x2: 5.99995,
    y2: 8.3238,
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.92383L5.43431 10.4895C5.58434 10.6395 5.78783 10.7238 6 10.7238C6.21217 10.7238 6.41566 10.6395 6.56569 10.4895L6 9.92383ZM2.56569 5.35814C2.25327 5.04572 1.74673 5.04572 1.43432 5.35814C1.1219 5.67056 1.1219 6.17709 1.43432 6.48951L2.56569 5.35814ZM10.5657 6.48951C10.8781 6.17709 10.8781 5.67056 10.5657 5.35814C10.2533 5.04572 9.74673 5.04572 9.43431 5.35814L10.5657 6.48951ZM6.56569 9.35814L2.56569 5.35814L1.43432 6.48951L5.43431 10.4895L6.56569 9.35814ZM9.43431 5.35814L5.43431 9.35814L6.56569 10.4895L10.5657 6.48951L9.43431 5.35814Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.e03342d19db470a042ae3302d2eb0355.svg";